var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99996 17.3333C4.39746 17.3333 0.666626 13.6025 0.666626 8.99999C0.666626 4.39749 4.39746 0.666656 8.99996 0.666656C13.6025 0.666656 17.3333 4.39749 17.3333 8.99999C17.3333 13.6025 13.6025 17.3333 8.99996 17.3333ZM8.16913 12.3333L14.0608 6.44082L12.8825 5.26249L8.16913 9.97666L5.81163 7.61916L4.63329 8.79749L8.16913 12.3333Z",
    fill: "#456786"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.4d6b3d07249ddbc913e05f390f793da7.svg";
export { ForwardRef as ReactComponent };